import type {DateRangeWithTimezone} from '@spaced-out/ui-design-system/lib/types';
import type {AnalyticsLinkClickInsightsUtmActions} from 'src/action-creators/analytics/analytics-link-click-insights-utm';
import {
  SET_SELECTED_DATE_RANGE,
  SET_CURRENT_DASHBOARD_ID,
  RECEIVE_LINK_CLICK_INSIGHTS_UTM_ALL_CLICKS_TABLE_COLUMNS,
  RECEIVE_LINK_CLICK_INSIGHTS_UTM_ALL_WORKFLOWS_TABLE_COLUMNS,
  RECEIVE_LINK_CLICK_INSIGHTS_UTM_ALL_NODES_TABLE_COLUMNS,
  RECEIVE_LINK_CLICK_INSIGHTS_UTM_UTM_ANALYSIS_TABLE_COLUMNS,
  RECEIVE_LINK_CLICK_INSIGHTS_UTM_ENGAGEMENT_TABLE_COLUMNS,
} from 'src/action-creators/analytics/analytics-link-click-insights-utm';
import type {SelectedLinkClickInsightsUtmFilterColumnsData} from 'src/types/analytics-genesis';

// Simple type definition for now
type FilterColumns = {
  table_columns: Array<string>;
};

export type AnalyticsLinkClickInsightsUtmState = {
  selectedDateRange: DateRangeWithTimezone;
  currentDashboardID: string | null | undefined;
  allClicksTableColumnFilter: SelectedLinkClickInsightsUtmFilterColumnsData | null;
  allWorkflowsTableColumnFilter: FilterColumns | null;
  allNodesTableColumnFilter: FilterColumns | null;
  utmAnalysisTableColumnFilter: FilterColumns | null;
  engagementTableColumnFilter: FilterColumns | null;
};

const initialState: AnalyticsLinkClickInsightsUtmState = {
  selectedDateRange: {
    startDateUTC: null,
    startDate: null,
    endDateUTC: null,
    endDate: null,
  },
  currentDashboardID: null,
  allClicksTableColumnFilter: null,
  allWorkflowsTableColumnFilter: null,
  allNodesTableColumnFilter: null,
  utmAnalysisTableColumnFilter: null,
  engagementTableColumnFilter: null,
};

export default (
  state: AnalyticsLinkClickInsightsUtmState = initialState,
  action: AnalyticsLinkClickInsightsUtmActions,
): AnalyticsLinkClickInsightsUtmState => {
  switch (action.type) {
    case SET_CURRENT_DASHBOARD_ID: {
      return {
        ...state,
        currentDashboardID: action.payload,
      };
    }
    case SET_SELECTED_DATE_RANGE: {
      return {
        ...state,
        selectedDateRange: action.payload,
      };
    }
    case RECEIVE_LINK_CLICK_INSIGHTS_UTM_ALL_CLICKS_TABLE_COLUMNS: {
      return {
        ...state,
        allClicksTableColumnFilter: action.payload,
      };
    }
    case RECEIVE_LINK_CLICK_INSIGHTS_UTM_ALL_WORKFLOWS_TABLE_COLUMNS: {
      return {
        ...state,
        allWorkflowsTableColumnFilter: {
          table_columns: action.payload.columns.table_columns,
        },
      };
    }
    case RECEIVE_LINK_CLICK_INSIGHTS_UTM_ALL_NODES_TABLE_COLUMNS: {
      return {
        ...state,
        allNodesTableColumnFilter: {
          table_columns: action.payload.columns.table_columns,
        },
      };
    }
    case RECEIVE_LINK_CLICK_INSIGHTS_UTM_UTM_ANALYSIS_TABLE_COLUMNS: {
      return {
        ...state,
        utmAnalysisTableColumnFilter: {
          table_columns: action.payload.columns.table_columns,
        },
      };
    }
    case RECEIVE_LINK_CLICK_INSIGHTS_UTM_ENGAGEMENT_TABLE_COLUMNS: {
      return {
        ...state,
        engagementTableColumnFilter: {
          table_columns: action.payload.columns.table_columns,
        },
      };
    }
  }
  return state;
};
